/*
 * @Description: 文件处理
 */

// ---------------------------------------------------------------------------

/**
 * 获取文件扩展名
 * @param {*} filePath
 */
function getFileExtension(filePath) {
	const parts = filePath.split('.');
	return parts.length > 1 ? parts.pop() : '';
}

// ---------------------------------------------------------------------------

/**
 * 获取文件名
 * @param {*} filePath
 */
function getFileName(filePath) {
	const parts = filePath.split('/');
	return parts.length > 1 ? parts.pop() : '';
}

// ---------------------------------------------------------------------------

/**
 * 获取图标
 * @param {*} filetype
 */
function getThumbnail(filetype) {
	switch (filetype.toLowerCase()) {
		case 'doc':
		case 'docx':
			return '/static/img/fileType/doc.png';
		case 'pdf':
			return '/static/img/fileType/pdf.png';
		case 'jpg':
		case 'png':
		case 'gif':
			return '/static/img/fileType/image.png';
		case 'ppt':
		case 'pptx':
			return '/static/img/fileType/ppt.png';
		case 'xlsx':
		case 'xls':
			return '/static/img/fileType/xlsx.png';
		default:
			return '/static/img/file.png';
	}
}

// ---------------------------------------------------------------------------

export default {
	value: {},
	method: {
		getFileExtension,
		getFileName,
		getThumbnail
	}
};